import * as yup from "yup";

export const voidDelayedContractSchema = yup.object({
  voided: yup.boolean(),
  voidComments: yup
    .string()
    .max(255, "Comments must be 255 characters or less")
    .required("Comments are required"),
});
